import { LAMPORTS_PER_SOL } from "@solana/web3.js"
import Decimal from "decimal.js"

export class LiquidationPoolState {
  public lifetimeDeposits: Decimal
  public hedgeInitRewardsTimestamp: number
  constructor(public liquidationPoolState: any) {
    this.lifetimeDeposits = new Decimal(liquidationPoolState.lifetimeDeposits.toString())
    this.hedgeInitRewardsTimestamp =
      liquidationPoolState.hedgeInitRewardsTimestamp.toNumber()
    // TODO Add the rest that are missing. Do we need them?
  }
  getCurrentHedgeRewardsPerDay() {
    const dailyRate = hedgeRewardsDecay(
      2000000.0 * LAMPORTS_PER_SOL,
      this.hedgeInitRewardsTimestamp * 1000,
      Date.now(),
      Date.now() + 24 * 60 * 60 * 1000,
      365 * 1000
    )
    return dailyRate / LAMPORTS_PER_SOL
  }
}


function hedgeRewardsDecay (supply, birthTime, timeIn, timeOut, halfLifeInDays) {
  const timeInOffsetStart = timeIn - birthTime
  const timeOutOffsetStart = timeOut - birthTime
  const halfLife = -1 * Math.log(2) / (halfLifeInDays * 60 * 60 * 24)
  const awardedTokens = supply * (Math.pow(Math.E, halfLife * timeInOffsetStart) - Math.pow(Math.E, halfLife * timeOutOffsetStart))
  return awardedTokens
}
